<!-- 系统参数 -->
<template>
	<div class="finance_box" ref="myElementRef">
		<el-form v-loading="state.loading" ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.toScore')" prop="toScore">
					<el-input-number v-model="state.form.toScore" class="width-220" :min="0" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.offScore')" prop="offScore">
					<el-input-number v-model="state.form.offScore" class="width-220" :min="0" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.goToWork')" prop="goToWork">
					<el-time-picker v-model="state.form.goToWork" format="HH:mm" value-format="HH:mm" clearable
						:placeholder="t('systemSetting.pleaseSelect')" class="width-220" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.goOffWork')" prop="goOffWork">
					<el-time-picker v-model="state.form.goOffWork" format="HH:mm" value-format="HH:mm" clearable
						:placeholder="t('systemSetting.pleaseSelect')" class="width-220" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.otScore')" prop="score">
					<el-input-number v-model="state.form.score" class="width-220" :min="0" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.maintenanceScore')" prop="maintenanceScore">
					<el-input-number v-model="state.form.maintenanceScore" class="width-220" :min="0" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.radius')" prop="radius">
					<el-input-number v-model="state.form.radius" class="width-220" :min="1" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.complaintDeduction')" prop="complaintDeduction">
					<el-input-number v-model="state.form.complaintDeduction" class="width-220" :min="0" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.nightShiftExtra')" prop="nightShiftSalaryExtra">
					<el-input-number v-model="state.form.nightShiftSalaryExtra" class="width-220" :min="0" :placeholder="t('systemSetting.defaultNightShift')" />
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="t('systemSetting.tongxiaoMultiplier')" prop="tongxiaoSalaryMultiplier">
					<el-input-number
						v-model="state.form.tongxiaoSalaryMultiplier"
						class="width-220"
						:min="0"
						:step="0.1"
						:precision="2"
						:placeholder="t('systemSetting.defaultTongxiao')"
					/>
				</el-form-item>
			</el-col>
		</el-form>
		<div class="btn_box">
			<el-button @click="clearForm">{{ t('systemSetting.restoreDefault') }}</el-button>
			<el-button type="primary" @click="submit">{{ t('systemSetting.save') }}</el-button>
		</div>
	</div>
</template>

<script setup>
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { getFormApi, saveApi } from "@/api/system/setting";
import { t } from "@/locale/index.js";
const ruleForm = ref()

const state = reactive({
	isLoading: false,
	form: {
		// "id": 0,
		"toScore": 1,
		"score": 10,
		"offScore": 1,
		"goToWork": "08:30",
		"goOffWork": "17:30",
		"maintenanceScore": 10,
		"radius": 500,
		"complaintDeduction": 1,
		"nightShiftSalaryExtra": 100,
		"tongxiaoSalaryMultiplier": 1
	},
	loading: true
});

const rules = reactive({
	toScore: [{ required: true, message: "请输入上机打卡分", trigger: "blur" }],
	offScore: [{ required: true, message: "请输入落机打卡分", trigger: "blur" }],
	score: [{ required: true, message: "请输入分数", trigger: "blur" }],
	goToWork: [{ required: true, message: "请输入上机打卡时间", trigger: "blur" }],
	goOffWork: [{ required: true, message: "请输入落机打卡时间", trigger: "blur" }],
	maintenanceScore: [{ required: true, message: "请输入完成保养分值", trigger: "blur" }],
	radius: [{ required: true, message: "请输入打卡有效半径", trigger: "blur" }],
	complaintDeduction: [{ required: true, message: "请输入投诉减分", trigger: "blur" }],
	nightShiftSalaryExtra: [{ required: true, message: "请输入夜班日薪加额", trigger: "blur" }],
	tongxiaoSalaryMultiplier: [{ required: true, message: "请输入通宵工资倍数", trigger: "blur" }],
})

const labelMap = reactive({
	"score": 'OT/中直打卡分',
	"toScore": '上机打卡分',
	"offScore": '落机打卡分',
	"goToWork": "上机打卡时间",
	"goOffWork": "落机打卡时间 ",
	"maintenanceScore": '保养分值',
	"radius": "打卡范围半径",
	"complaintDeduction": "投诉减分"
})

const getForm = () => {
	state.loading = true
	getFormApi('{}').then((res) => {
		state.form = {
			...state.form,
			...(res.data || {})
		};
		state.loading = false
	});
}

const clearForm = () => {
	state.form = {
		"score": 10,
		"toScore": 1,
		"offScore": 1,
		"goToWork": "08:30",
		"goOffWork": "17:30",
		"maintenanceScore": 10,
		"radius": 500,
		"complaintDeduction": 1,
		"nightShiftSalaryExtra": 100,
		"tongxiaoSalaryMultiplier": 1
	};
}

const submit = () => {
	ruleForm.value.validate((valid) => {
		if (valid) {
			const params = JSON.stringify({
				...state.form,
				complaint_deduction: state.form.complaintDeduction,
				go_to_work: state.form.goToWork,
				go_off_work: state.form.goOffWork,
				maintenance_score: state.form.maintenanceScore,
				to_score: state.form.toScore,
				off_score: state.form.offScore,
				score: state.form.score,
				night_shift_salary_extra: state.form.nightShiftSalaryExtra,
				tongxiao_salary_multiplier: state.form.tongxiaoSalaryMultiplier,
			})
			saveApi(params).then(res => {
				if (res?.code === 200) {
					ElMessage.success(t('systemSetting.saveSuccess'));
					getForm();
				} else {
					ElMessage.error(res?.msg || t('systemSetting.saveFailed'));
				}
			})
		}
	})
}

onMounted(() => {
	try {
		getForm();
	} catch (e) {
	}
});
</script>

<style lang="less" scoped>
.finance_box {
	flex: 1;
	overflow: auto;
	background-color: #fff;
	border-radius: 6px;
	padding: 10px;
	margin-right: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.man_m {
	margin-top: 20px;
}

.title {
	font-weight: bold;
	padding-left: 15px;
	position: relative;
}

.title::before {
	content: "122";
	width: 4px;
	height: 15px;
	font-size: 1px;
	position: absolute;
	left: 0;
	top: 6px;
	color: #1f9fb5;
	border-radius: 5px;
	background-color: #1f9fb5;
}

.userFrom {
	width: 80%;
  display: grid;
  gap: 20px;
  /* 可选，添加网格项之间的间隙 */
  grid-template-columns: repeat(2, 1fr);
}

.width-220 {
	width: 220px;
}

.btn_box {
	display: flex;
	justify-content: center;
	margin-top: 80px;
}

.item_list {
	display: flex;
	align-items: center;
}

.man_item {
	font-size: 14px;
	padding: 20px;
	display: grid;
	gap: 20px;
	/* 可选，添加网格项之间的间隙 */
	grid-template-columns: repeat(2, 1fr);
}

.man_stting {
	display: grid;
	gap: 20px;
	/* 可选，添加网格项之间的间隙 */
	grid-template-columns: repeat(3, 1fr);
}

.input_day {
	width: 100px;
	margin: 0 20px;
}

.item_l {
	min-width: 260px;
	text-align: right;
	font-size: 14px;
}

.item_title {
	min-width: 170px;
	margin-right: 15px;
	text-align: right;
}

.che_title {
	width: 160px;
	text-align: right;
	font-size: 14px;
	margin-right: 15px;
}

.input_stting {
	width: 50%;
}

.chexbox {
	padding: 0 30px;
	margin-top: 20px;
}
</style>
